import { render, staticRenderFns } from "./SquareMetersPriceChartTrend.vue?vue&type=template&id=4b4181ae&scoped=true&"
import script from "./SquareMetersPriceChartTrend.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceChartTrend.vue?vue&type=script&lang=js&"
import style0 from "./SquareMetersPriceChartTrend.vue?vue&type=style&index=0&id=4b4181ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4181ae",
  null
  
)

export default component.exports